document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.participants-receive');
  if (!sections.length) return;

  const mediaQuery = window.matchMedia('(min-width: 750px)');

  sections.forEach((sectionEl) => {
    const measureAndApply = () => {
      const titles = Array.from(sectionEl.querySelectorAll('.item-title'));
      if (titles.length < 2) return;

      titles.forEach((el) => {
        el.style.height = '';
      });

      if (!mediaQuery.matches) return;

      let max = 0;
      titles.forEach((el) => {
        const h = el.getBoundingClientRect().height;
        if (h > max) max = h;
      });

      if (max <= 0) return;
      titles.forEach((el) => {
        el.style.height = `${Math.ceil(max)}px`;
      });
    };

    let raf = 0;
    const schedule = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        raf = 0;
        measureAndApply();
      });
    };

    schedule();
    window.addEventListener('resize', schedule, { passive: true });
    
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', schedule);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(schedule);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule).catch(() => {});
    }

    if (window.ResizeObserver) {
      const ro = new ResizeObserver(() => schedule());
      ro.observe(sectionEl);
    }
  });
});